import { Fancybox } from "@fancyapps/ui";

document.addEventListener("DOMContentLoaded", function () {
    try {
        Fancybox.unbind("[data-fancybox]");
        Fancybox.bind("[data-fancybox]:not(.slick-cloned a)", {
            groupAll: false,
        });
    } catch (e) {
        console.error(e);
    }
});
